import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { Button } from '../ui/Button';
import { Leaf } from 'lucide-react';
export function Closing() {
  return <section className="py-16 md:py-24 bg-brand-sand/30" data-id="element-60">
      <div className="max-w-3xl mx-auto px-6 text-center" data-id="element-61">
        <FadeIn data-id="element-62">
          <Leaf className="w-6 h-6 text-brand-eucalyptus mx-auto mb-8 opacity-60" strokeWidth={1.5} data-id="element-63" />
          <p className="font-serif text-2xl md:text-3xl lg:text-4xl text-brand-ink leading-relaxed mb-12" data-id="element-64">
            No tienes que tenerlo todo resuelto para empezar a volver a ti. A
            veces el primer paso es permitir que alguien mire contigo el mapa.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-65">
          <Button href="https://api.leadconnectorhq.com/widget/booking/kiMwaUwzHpX0z6UxKbPj" variant="primary" data-id="element-66">
            Quiero agendar mi llamada
          </Button>
        </FadeIn>
      </div>
    </section>;
}